import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { SelectionBoxAccounts } from "./SelectionBoxAccounts";

const COMBINED_OPTION = { value: "Combined", display: "All accounts" };

export function AccountSelectionComponent({ accounts = {}, includeCombined, handleSelect, value }) {
    const createOptionForAccount = key => {
        const account = accounts[key];

        return {
            value: account.accountNumber,
            display: `${account.wrapperType} ${account.accountNumber}`,
            status: account.accountStatus
        };
    };

    const getAccountOptions = () => {
        const accountKeys = Object.keys(accounts);

        return []
            .concat(includeCombined && accountKeys.length > 1 ? COMBINED_OPTION : [])
            .concat(accountKeys.map(createOptionForAccount));
    };

    const options = getAccountOptions();

    if (options.length === 1) {
        return null;
    }

    return <SelectionBoxAccounts options={options} value={value} handleSelect={handleSelect} />;
}

AccountSelectionComponent.propTypes = {
    accounts: PropTypes.object,
    handleSelect: PropTypes.func,
    includeCombined: PropTypes.bool,
    value: PropTypes.string
};

const mapStateToProps = state => ({
    accounts: state.accounts
});

export const AccountSelection = connect(mapStateToProps)(AccountSelectionComponent);
